<p>dtr-manager works!</p>
